module.exports = __webpack_public_path__ + "img/chips20.c60d1581.webp";